<template>
  <b-card>
    <b-row>
      <b-col
          class="table-size"
      >
        <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 20px">
          <h4>مدیریت محصولات</h4>
          <b-button
              variant="primary"
              :to="{ name: 'addProduct'}"
          >
            جدید
          </b-button>
        </div>
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'addProduct', params: { id: data.item.Id }}"
                class="font-weight-bold"
            >
              #{{ data.item.Id }}
            </b-link>
          </template>

          <template #cell(Status)="data">
            <b-badge :variant="enums('productStatus', 'value', data.item.Status, 'badge')"
            >
              {{ enums('productStatus', 'value', data.item.Status, 'text') }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
                class="text-nowrap"
            >
              <b-link :to="{ name: 'updateProduct', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

      </b-col>

    </b-row>
  </b-card>
</template>

<script>
import product from "@/modules/apies/product/product";

export default {
  name: 'Products',
  data() {
    return {
      loading: false,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Route',
          label: 'مسیر',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    this.update()
  },
  methods: {
    update() {
      this.loading = true

      this.$http.get(
          this.$api.product.getlist,
      )
          .then(res => {
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.$bvModal.msgBoxConfirm('آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟', {
        title: 'حذف',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'تایید',
        cancelTitle: 'انصراف',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
        modalClass: 'modal-danger modal-remove-confirm',
      }).then(confirm => {
        if (confirm) {
          this.$http.post(this.$api.product.remove, { Id: id }).then(() => {
            this.update()
          })
        }
      })
    },
  },
}
</script>
